import React from 'react';
import Header from './Header';
import Footer from './Footer';
import MobileNavigation from './MobileNavigation';
import ChatPopover from '../Chat/ChatPopover';
import IncomingCallOverlay from '../UI/IncomingCallOverlay';
import CartDrawer from '../Cart/CartDrawer';
import AISupportChat from '../UI/AISupportChat';
import { useAISupport } from '../../contexts/AISupportContext';

function Layout({ children }) {
    const { aiSupportVisible, closeAISupport } = useAISupport();

    const handleEscalateToHuman = (escalationData) => {
        // Handle escalation to human support
        console.log('Escalating to human support:', escalationData);
        // You can integrate with your existing chat system here
        // For now, we'll just show a message
        alert('Connecting you to a human support agent...');
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <Header />
            <main className="flex-1 pb-16 md:pb-0">
                {children}
            </main>
            <Footer />
            <MobileNavigation />
            <ChatPopover />
            <IncomingCallOverlay />
            <CartDrawer />
            <AISupportChat
                visible={aiSupportVisible}
                onClose={closeAISupport}
                onEscalate={handleEscalateToHuman}
                position="bottom-right"
            />
        </div>
    );
}

export default Layout;
